import { Reducer } from 'umi';

export const namespace = 'guide';

export {
  GUIDE_SYS_OPINION,
  GUIDE_TYPE_OPINION_OVERVIEW,
  GUIDE_TYPE_OPINION_FEEDS,
  GUIDE_TYPE_OPINION_GAME_STORE,
  GUIDE_TYPE_OPINION_COMMUNITY,
  GUIDE_TYPE_OPINION_COMPETITOR,
  GUIDE_TYPE_OPINION_DATA_SOURCE,
} from './guide-opinion';
import { reducers as reducersOpinion } from './guide-opinion';

export {
  GUIDE_SYS_INTELLIGENCE,
  GUIDE_TYPE_INTELLIGENCE_COMPETITOR,
  GUIDE_TYPE_INTELLIGENCE_COMPANY,
  GUIDE_TYPE_INTELLIGENCE_GENRE_MARKET_PROFILE,
  GUIDE_TYPE_INTELLIGENCE_MARKET_REPORTS,
  GUIDE_TYPE_INTELLIGENCE_FOLLOWING,
  GUIDE_TYPE_INTELLIGENCE_SOURCES_METRICS,
  GUIDE_TYPES_INTELLIGENCE,
} from './guide-intelligence';
import { reducers as reducersIntelligence } from './guide-intelligence';

export const GUIDE_SYS_DASHBOARD = 'dashboard';
export const GUIDE_SYS_HOME = 'home';

export const GUIDE_TYPE_DASHBOARD_OVERVIEW = 'dashboard-overview';
export const GUIDE_TYPE_DASHBOARD_REALTIME = 'dashboard-realtime';
export const GUIDE_TYPE_DASHBOARD_COUNTRY = 'dashboard-country';
export const GUIDE_TYPE_DASHBOARD_TABLEAU = 'dashboard-tableau';
export const GUIDE_TYPE_DASHBOARD_SUBSCRIBE = 'dashboard-subscribe';

export interface GuideModelStateType {
  guideSys: string; // 指引类型: '' | dashboard | home | intelligence | opinion
  guideType: string; // 当前显示的指引  overview-daily, realtime-user
}

export interface GuideModelType {
  namespace: string;
  state: GuideModelStateType;
  effects: {};
  reducers: {
    save: Reducer<GuideModelStateType>;
    showDashboardGuideModule: Reducer<GuideModelStateType>;
    showDashboardGuideOverview: Reducer<GuideModelStateType>;
    showDashboardGuideRealtime: Reducer<GuideModelStateType>;
    showDashboardGuideCountry: Reducer<GuideModelStateType>;
    showDashboardGuideTableau: Reducer<GuideModelStateType>;
    showDashboardGuideSubscribe: Reducer<GuideModelStateType>;
    // 启用 immer 之后
    // save: ImmerReducer<IndexModelState>;

    showOpinionGuideModule: Reducer<GuideModelStateType>;
    showOpinionGuideOverview: Reducer<GuideModelStateType>;
    showOpinionGuideFeeds: Reducer<GuideModelStateType>;
    showOpinionGuideGameStore: Reducer<GuideModelStateType>;
    showOpinionGuideCommunity: Reducer<GuideModelStateType>;
    showOpinionGuideCompetitor: Reducer<GuideModelStateType>;
    showOpinionGuideDataSource: Reducer<GuideModelStateType>;
  };
  // subscriptions: { setup: Subscription };
}

const GuideModel: GuideModelType = {
  namespace: namespace,

  state: {
    guideSys: '',
    guideType: '',
  },

  effects: {},
  reducers: {
    save(state: GuideModelStateType, action: any) {
      return {
        ...state,
        ...action.payload,
      };
    },
    ...reducersOpinion,
    ...reducersIntelligence,
    showDashboardGuideModule(state: GuideModelStateType, action: any) {
      return {
        ...state,
        guideSys: action.payload ? GUIDE_SYS_DASHBOARD : '',
        ...{
          guideType: '',
        },
      };
    },
    showDashboardGuideOverview(state: GuideModelStateType) {
      return {
        ...state,
        ...{
          guideSys: '',
          guideType: GUIDE_TYPE_DASHBOARD_OVERVIEW,
        },
      };
    },
    showDashboardGuideRealtime(state: GuideModelStateType) {
      return {
        ...state,
        ...{
          guideSys: '',
          guideType: GUIDE_TYPE_DASHBOARD_REALTIME,
        },
      };
    },
    showDashboardGuideCountry(state: GuideModelStateType) {
      return {
        ...state,
        ...{
          guideSys: '',
          guideType: GUIDE_TYPE_DASHBOARD_COUNTRY,
        },
      };
    },
    showDashboardGuideTableau(state: GuideModelStateType) {
      return {
        ...state,
        ...{
          guideSys: '',
          guideType: GUIDE_TYPE_DASHBOARD_TABLEAU,
        },
      };
    },

    showDashboardGuideSubscribe(state: GuideModelStateType) {
      return {
        ...state,
        ...{
          guideSys: '',
          guideType: GUIDE_TYPE_DASHBOARD_SUBSCRIBE,
        },
      };
    },
  },
};

export default GuideModel;
